var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "apply_info", attrs: { id: "apply_info" } }, [
    _c("strong", { staticClass: "tit_apply" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("span", { staticClass: "txt_schedule" }, [
      _c("span", { staticClass: "ico_cafe ico_calendar" }, [_vm._v("기간")]),
      _c("span", { attrs: { id: "apply_due" } }, [_vm._v(_vm._s(_vm.due))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpenDetail,
            expression: "isOpenDetail"
          }
        ],
        staticClass: "detail_apply",
        attrs: { id: "detail_apply" }
      },
      [
        _c("pre", { attrs: { id: "desc_apply" } }, [_vm._v(_vm._s(_vm.desc))]),
        _vm._v(" "),
        _c("div", { staticClass: "wrap_list" }, [
          _c(
            "ul",
            {
              staticClass: "list_thumb",
              class: {
                list_thumb_type1: _vm.images.length === 1,
                list_thumb_type2: _vm.images.length !== 1
              },
              style: _vm.ulTagWidth,
              attrs: { id: "list_thumb" }
            },
            _vm._l(_vm.images, function(image, index) {
              return _c("li", {
                key: index,
                staticClass: "info_image #noti_image_viewer",
                style: _vm.imageStyle(
                  image,
                  _vm.thumbnailSize.width,
                  _vm.thumbnailSize.height
                ),
                on: {
                  click: function($event) {
                    return _vm.goImageUrl(image)
                  }
                }
              })
            }),
            0
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn_apply",
        attrs: { type: "button", id: "btn_noti_fold" },
        on: { click: _vm.toggleDetail }
      },
      [
        _c("span", { staticClass: "noti_fold_title" }, [
          _vm._v(_vm._s(_vm.buttonMessage))
        ]),
        _c("span", {
          staticClass: "ico_cafe",
          class: { ico_open: !_vm.isOpenDetail }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }